// Pure decision logic for autofilling the add-house area/construction_year fields from a
// PdokAddressTypeahead `resolved` payload's `enrichment` object (BAG floor-area/construction-year
// enrichment - see App\Services\Address\AddressEnrichmentService::resolve()).
//
// Kept as a plain, dependency-free function (no Vue, no DOM) specifically so it is independently
// unit-testable via Vitest: add-house.blade.php's own Vue instance is inline Blade script, not an
// importable module, so this is the one piece of that page's enrichment-autofill behaviour that
// can be exercised directly rather than only through the page itself.
//
// Rules (mirrors this task's own autofill requirements):
// - Only a non-null/non-undefined enrichment.area / enrichment.construction_year may fill its
//   field - a partial/ambiguous/unavailable/not_applicable result simply omits the field(s) it
//   could not resolve, and those are left untouched here.
// - A field the user has manually edited since the last autofill is never overwritten - even by
//   a fresh, otherwise-valid enrichment value (this is also what protects against a delayed/stale
//   response: PdokAddressTypeahead's own request-token guard means only the newest response ever
//   reaches this function at all, so "stale" here specifically means "user edited it since").
// - A brand new resolved address is always a fresh baseline: the manual-edit flags reset after
//   this call, whether or not this address itself had anything to autofill.
export function applyEnrichmentToState(state, enrichment) {
  var next = {
    area: state.area,
    constructionYear: state.constructionYear,
    areaManuallyEdited: false,
    constructionYearManuallyEdited: false,
  };

  if (enrichment) {
    if (!state.areaManuallyEdited && enrichment.area !== null && enrichment.area !== undefined) {
      next.area = String(enrichment.area).replace('.', ',');
    }
    if (!state.constructionYearManuallyEdited && enrichment.construction_year !== null && enrichment.construction_year !== undefined) {
      next.constructionYear = String(enrichment.construction_year);
    }
  }

  return next;
}

export default applyEnrichmentToState;
